
//permisions

export const modulesDataSI = [
    {
      "module": "support",
      "actions": ["reply", "view","request remote access","access design studio","share ticket"]
    },
    {
      "module": "project manager",
      "actions": ["view", "add","edit","delete"]
    },
    {
      "module": "inventory",
      "actions": ["view"]
    },
    {
      "module": "user",
      "actions": ["view","add","edit"]
    },
    {
      "module": "role",
      "actions": ["view","add","edit"]
    },
    {
      "module": "project detail",
      "actions":  ["view","add","edit","delete"]
    },
    {
      "module": "office location",
      "actions":  ["view", "add","delete"]
    },
  ];



  export const modulesDataDistributor = [
    {
      "module": "support",
      "actions": ["reply", "view","request remote access","access design studio","share ticket"]
    },
    {
      "module": "system integrator",
      "actions": ["view", "add","edit","delete"]
    },
    {
      "module": "okas inventory",
      "actions":  ["view","assign"]
    },
    {
      "module": "member licence",
      "actions":  ["view","assign"]
    },
    {
      "module": "user",
      "actions": ["view","add","edit"]
    },
    {
      "module": "role",
      "actions": ["view","add","edit"]
    },
  ]
  